<template>
  <div class="d-flex align-center justify-center" style="width: 100vw; height: 100vh;">
    <div>
      <div class="text-h4 font-weight-bold text-center mb-10"
        >Saving Data. This may take a few seconds.</div
      >
      <div class="d-flex justify-center">
        <v-progress-circular
          :size="300"
          :width="8"
          :value="currentProgress"
          :indeterminate="currentProgress >= 100"
          rotate="-90"
          :color="color"
        ></v-progress-circular>
      </div>
      <div class="text-center progressText mt-5">
        {{ progressText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentProgress: {
      type: Number,
      default: 0,
    },
    progressText: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'blue darken-2',
    },
  },
}
</script>

<style>
.progressText {
  max-width: 500px;
  margin: auto;
}
</style>
